// Dashboard Constants - Zorg-Vleugel

export const API_URL = process.env.REACT_APP_BACKEND_URL;

// Quick Reply opties per categorie - Professionele versie zonder emoji's
export const QUICK_REPLIES = {
  'default': [
    { text: 'Hoe begin ik mijn dienst?' },
    { text: 'Medicatie uitleg' },
    { text: 'Help met rapportage' },
    { text: 'Wie is er vandaag?' },
  ],
  'inwerken': [
    { text: 'Ochtenddienst checklist' },
    { text: 'Avonddienst checklist' },
    { text: 'Systemen uitleg' },
    { text: 'Huisafspraken' },
  ],
  'medicatie': [
    { text: 'Leg de 5 J\'s uit' },
    { text: 'Dubbele controle nodig?' },
    { text: 'Medicatie mist!' },
    { text: 'Welke cliënt heeft welke medicatie?' },
  ],
  'clienten': [
    { text: 'Toon alle cliënten' },
    { text: 'Signaleringsplan zoeken' },
    { text: 'Zorgdoelen bekijken' },
    { text: 'Wie heeft dienst?' },
  ],
  'veiligheid': [
    { text: 'Start brandoefening', variant: 'danger' },
    { text: 'Verzamelplaatsen' },
    { text: 'Brandblussers locaties' },
    { text: 'Bij agressie?' },
  ],
  'brand': [
    { text: 'Start brandoefening', variant: 'danger' },
    { text: 'Ik ben op Ardennenlaan 68' },
    { text: 'Ik ben op Enschotsestraat 68' },
    { text: 'Ik ben op Enschotsestraat 98' },
    { text: 'Ik ben op Enschotsestraat 100' },
  ],
  'protocollen': [
    { text: 'SOEP methode uitleg' },
    { text: 'MIC melding maken' },
    { text: 'Overdracht schrijven' },
    { text: 'Help met rapportage' },
  ],
};

// Dienst Schema - Taken per tijdslot voor alle diensten
// Structuur met 'sections' array voor UI rendering
export const SHIFT_TASKS = {
  dagdienst: {
    name: 'Dagdienst',
    icon: 'Sun',
    timeRange: '08:00 - 23:00',
    color: '#1e3a5f',
    reminders: [
      'Groepstelefoon ALTIJD aan + geluid aan',
      'Lees de overdracht van gisteren (ochtend)'
    ],
    sections: [
      {
        id: 'ochtend',
        name: 'Ochtend',
        icon: '☀️',
        timeRange: '07:45 - 12:00',
        tasks: [
          { time: '07:45', title: 'Aankomst & Overdracht lezen', description: 'Lees de rapportage van GISTEREN in Doctor Sillo. Check groepsmail.', important: true },
          { time: '08:00', title: 'Ontbijt begeleiden', description: 'Ontbijt klaarzetten, cliënten begeleiden bij opstaan.' },
          { time: '08:00', title: 'Medicatie Ochtend', description: '5 J\'s toepassen, voorraad checken, aftekenlijst.', important: true },
          { time: '08:30', title: 'Ochtend activiteiten', description: 'ADL begeleiding, dagbesteding voorbereiden.' },
          { time: '09:30', title: 'CONTACTMOMENT 1', description: 'Beloonsysteem bespreken. Doelen uit zorgplan.', important: true, highlight: true },
          { time: '10:00', title: 'Activiteiten begeleiding', description: 'Begeleiding bij dagbesteding of vrije tijd.' },
          { time: '12:00', title: 'Lunch', description: 'Lunch begeleiden, medicatie indien nodig.' },
        ]
      },
      {
        id: 'middag',
        name: 'Middag',
        icon: '🌤️',
        timeRange: '13:00 - 17:30',
        tasks: [
          { time: '13:00', title: 'CONTACTMOMENT 2', description: 'Punten evalueren. Doelen bespreken. Middagplannen.', important: true, highlight: true },
          { time: '13:30', title: 'Middagactiviteiten', description: 'Begeleiding bij activiteiten of rust.' },
          { time: '15:00', title: 'Tussentijdse check', description: 'Hoe gaat het? Zijn er bijzonderheden?' },
          { time: '17:00', title: 'Avondeten voorbereiden', description: 'Maaltijd klaarmaken of begeleiding hierbij.' },
          { time: '17:30', title: 'Avondeten', description: 'Gezamenlijk eten, gezellig moment.' },
        ]
      },
      {
        id: 'avond',
        name: 'Avond',
        icon: '🌅',
        timeRange: '17:45 - 23:00',
        tasks: [
          { time: '17:45', title: 'CONTACTMOMENT 3', description: 'Dag evalueren. Punten tellen. Hoe was de dag?', important: true, highlight: true },
          { time: '18:00', title: 'Avond activiteit', description: 'Vrije tijd of geplande activiteit.' },
          { time: '18:30', title: 'Medicatie Avond', description: '5 J\'s toepassen. Alleen voor wie dit nodig heeft.', important: true },
          { time: '20:00', title: 'Overdracht schrijven', description: 'Rapportage in Doctor Sillo.', important: true },
          { time: '21:00', title: 'Avondroutine', description: 'Voorbereiden op nachtrust. Rustige sfeer.' },
          { time: '23:00', title: 'Einde dagdienst', description: 'Overdracht aan achterwacht (indien van toepassing).' },
        ]
      }
    ]
  },
  dagbesteding: {
    name: 'Dagbesteding',
    icon: 'Briefcase',
    timeRange: '08:00 - 17:00',
    color: '#2563eb',
    sections: [
      {
        id: 'ochtend',
        name: 'Ochtend & Vertrek',
        icon: '🚐',
        timeRange: '08:00 - 12:00',
        tasks: [
          { time: '07:45', title: 'Aankomst & Overdracht lezen', description: 'Lees rapportage van GISTEREN. Check groepsmail.', important: true },
          { time: '08:00', title: 'Ontbijt begeleiden', description: 'Ontbijt klaarzetten.' },
          { time: '08:00', title: 'Medicatie Ochtend', description: '5 J\'s toepassen, aftekenlijst invullen.', important: true },
          { time: '08:30', title: 'Ochtend activiteiten', description: 'ADL begeleiding.' },
          { time: '09:30', title: 'CONTACTMOMENT 1', description: 'Beloonsysteem. Herinneren aan dagbesteding!', important: true, highlight: true },
          { time: '10:00', title: 'Dagbesteding check', description: 'Wie gaat waarheen? Vervoer geregeld?' },
          { time: '11:00', title: 'Huishoudelijke taken', description: 'Corvee, boodschappen indien nodig.' },
          { time: '12:00', title: 'Lunch', description: 'Lunch begeleiden.' },
        ]
      },
      {
        id: 'middag',
        name: 'Middag & Terugkomst',
        icon: '🏠',
        timeRange: '13:00 - 17:30',
        tasks: [
          { time: '13:00', title: 'CONTACTMOMENT 2', description: 'Hoe gaat de dag? Terugkoppeling dagbesteding.', important: true, highlight: true },
          { time: '13:30', title: 'Middagactiviteiten', description: 'Vrije tijd of geplande activiteiten.' },
          { time: '15:00', title: 'Tussentijdse check', description: 'Bijzonderheden? Stemming?' },
          { time: '16:00', title: 'Terugkomst dagbesteding', description: 'Ontvangen cliënten, navragen hoe het was.' },
          { time: '17:00', title: 'Avondeten voorbereiden', description: 'Koken of begeleiding hierbij.' },
          { time: '17:30', title: 'Avondeten', description: 'Gezamenlijk eten.' },
        ]
      },
      {
        id: 'avond',
        name: 'Avond',
        icon: '🌆',
        timeRange: '17:45 - 20:00',
        tasks: [
          { time: '17:45', title: 'CONTACTMOMENT 3', description: 'Dag evalueren. Hoe was dagbesteding?', important: true, highlight: true },
          { time: '18:00', title: 'Avond activiteit', description: 'Vrije tijd, ontspanning.' },
          { time: '18:30', title: 'Medicatie Avond', description: '5 J\'s toepassen.', important: true },
          { time: '19:30', title: 'Overdracht schrijven', description: 'Rapportage in Doctor Sillo.', important: true },
          { time: '20:00', title: 'Overdracht aan achterwacht', description: 'Bij de deur, bijzonderheden delen.' },
        ]
      }
    ]
  },
  nachtdienst: {
    name: 'Nachtdienst',
    icon: 'Moon',
    timeRange: '23:00 - 08:00',
    color: '#4B5563',
    reminders: [
      'Telefoon ALTIJD bij de hand',
      'Ken de noodprocedures',
      'Bij twijfel: bel de achterwacht of 112',
    ],
    sections: [
      {
        id: 'nacht',
        name: 'Nachtdienst Taken',
        icon: '🌙',
        timeRange: '22:45 - 07:00',
        tasks: [
          { time: '22:45', title: 'Aankomst & Overdracht', description: 'Overdracht van dagdienst, bijzonderheden.', important: true },
          { time: '23:00', title: 'Nachtrondes starten', description: 'Regelmatige check op cliënten.' },
          { time: '00:00', title: 'Controle ronde', description: 'Alle cliënten op kamer?' },
          { time: '02:00', title: 'Controle ronde', description: 'Alles rustig?' },
          { time: '04:00', title: 'Controle ronde', description: 'Bijzonderheden noteren.' },
          { time: '06:00', title: 'Voorbereiden ochtend', description: 'Ontbijt voorbereiden indien nodig.' },
          { time: '07:00', title: 'Overdracht aan dagdienst', description: 'Bijzonderheden van de nacht doorgeven.', important: true },
        ]
      }
    ]
  }
};

// AI Chat Categorieën - Zonder emoji's
export const AI_CHAT_CATEGORIES = [
  { id: 'inwerken', name: 'Eerste Dienst', icon: 'BookOpen', color: '#10B981' },
  { id: 'medicatie', name: 'Medicatie', icon: 'Pill', color: '#8B5CF6' },
  { id: 'clienten', name: 'Cliënten', icon: 'Users', color: '#EC4899' },
  { id: 'veiligheid', name: 'Veiligheid', icon: 'ShieldAlert', color: '#EF4444' },
  { id: 'protocollen', name: 'Protocollen', icon: 'ClipboardList', color: '#10B981' },
  { id: 'huisafspraken', name: 'Huisafspraken', icon: 'Home', color: '#F59E0B' },
];

// Theme settings
export const THEME = {
  primaryColor: '#1e3a5f',
  secondaryColor: '#2d5a87',
  accentColor: '#10B981',
  warningColor: '#F59E0B',
  dangerColor: '#EF4444',
};

// Quick Actions
export const QUICK_ACTIONS = [
  { id: 'medication', label: 'Medicatie', icon: 'Pill' },
  { id: 'schedule', label: 'Rooster', icon: 'Calendar' },
  { id: 'clients', label: 'Cliënten', icon: 'Users' },
];

// Helper function: Get current shift type based on time
export function getCurrentShiftType() {
  const hour = new Date().getHours();
  if (hour >= 8 && hour < 15) return 'dagdienst';
  if (hour >= 15 && hour < 23) return 'avonddienst';
  return 'nachtdienst';
}

// Helper function: Get current section based on time
export function getCurrentSection() {
  const hour = new Date().getHours();
  if (hour >= 6 && hour < 12) return 'ochtend';
  if (hour >= 12 && hour < 17) return 'middag';
  if (hour >= 17 && hour < 23) return 'avond';
  return 'nacht';
}

// Helper function: Get current task based on time and shift
export function getCurrentTask(shiftType = 'dagdienst') {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const currentTimeStr = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;
  
  const shift = SHIFT_TASKS[shiftType];
  if (!shift || !shift.sections) return null;
  
  // Collect all tasks from all sections
  let allTasks = [];
  shift.sections.forEach(section => {
    if (section.tasks) {
      allTasks = [...allTasks, ...section.tasks];
    }
  });
  
  // Find the current or next task
  for (let i = 0; i < allTasks.length; i++) {
    if (allTasks[i].time >= currentTimeStr) {
      return allTasks[i];
    }
  }
  
  return allTasks[allTasks.length - 1] || null;
}

